import * as Yup from 'yup';

const MAX_FILE_SIZE = 22 * 1024 * 1024; // 22MB
const SUPPORTED_FILE_FORMATS = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf',
];

export const categoryValidationSchema = Yup.object({
    name: Yup.string()
        .nullable()
        .max(
            40,
            'Category name must not exceed 40 characters (including spaces)',
        )
        .required('Required'),
    accountingAccountNumber: Yup.string()
        .nullable()
        .max(
            20,
            'Account number must not exceed 40 characters (including spaces)',
        ),
});

export const categoryBexioValidationSchema = Yup.object({
    name: Yup.string()
        .nullable()
        .max(
            40,
            'Category name must not exceed 40 characters (including spaces)',
        )
        .required('Required'),
    accountingAccountNumber: Yup.string()
        .nullable()
        .max(
            20,
            'Account number must not exceed 40 characters (including spaces)',
        )
        .required('Required'),
});

export const vatValidationSchema = Yup.object({
    value: Yup.string().nullable().required('Required'),
    name: Yup.string()
        .nullable()
        .max(40, 'Vat name must not exceed 40 characters (including spaces)')
        .when('externalId', {
            is: externalId => !externalId,
            then: Yup.string().required(),
        }),
});

export const expenseFormValidationSchema = Yup.object({
    vat: Yup.array().of(
        Yup.object({
            rate: Yup.string()
                .nullable()
                .test({
                    name: 'valid-rate',
                    message: 'Invalid rate',
                    test: val => {
                        return !!val && Number(val) >= 0 && Number(val) < 100;
                    },
                }),
            amount: Yup.string().nullable().required('Required'),
            grossAmount: Yup.string().nullable().required('Required'),
        }),
    ),
});

export const expenseFileUploadValidationSchema = Yup.object({
    file: Yup.mixed()
        .test(
            'fileSize',
            'File size is bigger than 22MB, please reduce the size and upload again.',
            value => value.size <= MAX_FILE_SIZE,
        )
        .test('fileFormat', 'Unsupported format', value =>
            SUPPORTED_FILE_FORMATS.includes(value.type),
        ),
});
